var _path, _path2, _path3, _path4, _mask, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWelcomeGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 0C18.3565 0 0 18.3557 0 41C0 63.6427 18.3565 82 41 82C63.6443 82 82 63.6427 82 41C82 18.3557 63.6443 0 41 0Z",
    fill: "#9DE5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3229 24.5028L23.7598 20.7851L19.7337 22.6917C19.4988 22.8071 19.2366 22.8071 19.034 22.6917L15.5835 20.7847L16.9791 24.498C17.0642 24.7162 17.0274 24.9772 16.881 25.1956L14.4316 28.9599L18.451 27.0287C18.6862 26.9136 18.948 26.9136 19.1507 27.0287L22.6053 28.9653L21.2246 25.2003C21.1395 24.9822 21.1765 24.7211 21.3229 24.5028Z",
    fill: "#00ADB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3539 33.5674H47.9529H45.4526H27.6027H18.2451V34.4824V41.1564H21.2184V63.568H61.6354V43.9895H61.6359V41.1564H64.6029H64.6074V33.5674H57.3539Z",
    fill: "#F3F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7785 24.2971C55.5968 25.3774 54.8479 26.6183 53.6684 27.7825C52.0767 29.3867 48.2862 30.9128 45.4916 31.4316C45.8327 28.7616 46.5804 24.6572 48.5635 22.6921C49.944 21.3151 51.3689 20.5582 52.5687 20.5582C53.3564 20.5582 54.0785 20.8962 54.779 21.5907C55.6188 22.4368 55.9332 23.2964 55.7785 24.2971ZM28.5115 25.3774C27.329 24.2073 26.5888 22.9685 26.4204 21.8874C26.2489 20.8861 26.5634 20.0336 27.4074 19.1863C28.1035 18.4867 28.828 18.1546 29.6182 18.1546C30.8118 18.1546 32.2418 18.9064 33.6237 20.2826C35.6047 22.2645 37.0715 26.5945 37.4099 29.1386C34.5891 28.773 30.2559 27.1211 28.5115 25.3774ZM58.1942 18.1921C54.6404 14.6416 49.3815 15.067 45.1481 19.287C43.3779 21.0452 42.3311 23.5019 41.6568 25.9005C40.7748 22.5012 39.0481 18.8904 37.0339 16.876C32.7941 12.6559 27.541 12.2261 23.9959 15.7804C22.0238 17.7363 21.2231 20.1189 21.6426 22.6777C21.9888 24.7695 23.1852 26.8817 25.0918 28.7832C26.1328 29.8158 27.5926 30.747 29.2025 31.543L29.434 31.6588H56.532L56.6822 31.543C56.818 31.4208 56.9682 31.31 57.0967 31.1886C58.9984 29.2855 60.1932 27.1733 60.5381 25.0799C60.964 22.5227 60.1562 20.1393 58.1942 18.1921Z",
    fill: "#F2633B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 8,
    width: 51,
    height: 56
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4316 63.5683H64.6071V8.85596H14.4316V63.5683Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5859 63.5682H44.838V31.772H37.5859V63.5682Z",
    fill: "#F2633B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2402 33.5679H64.6026V31.4941H18.2402V33.5679Z",
    fill: "#E25326"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6353 41.1636H21.2178V43.9898H61.6353V41.1716V41.1636Z",
    fill: "#C0C1C2",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5049 14.7474L52.3662 8.85691L45.987 11.8778C45.6146 12.0607 45.1993 12.0607 44.878 11.8778L39.411 8.85596L41.6226 14.7398C41.7571 15.0854 41.6988 15.4992 41.4669 15.8451L37.5859 21.8097L43.9544 18.7497C44.3273 18.567 44.7421 18.567 45.0632 18.7497L50.5367 21.8181L48.3493 15.8526C48.2141 15.507 48.2731 15.0933 48.5049 14.7474Z",
    fill: "#00ADB2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeGift);
export default __webpack_public_path__ + "static/media/welcome_gift.49e7aa4c75c5d7aa6969c28bc6961477.svg";
export { ForwardRef as ReactComponent };